export enum FileMimeType {
    PNG = 'image/png',
    JPG = 'image/jpg',
    JPEG = 'image/jpeg',
    // Map 
    KML = 'application/vnd.google-earth.kml+xml',
    // Firmware
    AFW = 'text/plain',
    SIG = 'text/plain',
    IMG = 'text/plain',
    ENC = 'text/plain',
    BIN = 'text/plain',
    // Confguration
    CFG = 'text/plain',
    // Plain file
    PLAIN = 'text/plain'
};